import {
  createFileRoute,
  useParams,
  useNavigate,
  Outlet,
  useLocation,
} from "@tanstack/react-router";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "sonner";

import { ProtectedRoute } from "@/components/protected-route";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { View, SS_Button } from "@/components/native-wrapper-ui";
import HeaderView from "@/components/headerView";

import JobInfoPanelView from "@/components/jobs/job-info-panel";

import { selectJobOverviewData } from "@/store/selectors";
import { updateNotesModal } from "@/store/slices/appStateSlice";
import NotesModal from "@/components/notes-modal";

export const Route = createFileRoute("/job/$jobId/$date")({
  component: () => (
    <ProtectedRoute>
      <JobOverviewPage />
    </ProtectedRoute>
  ),
});

function JobOverviewPage() {
  const { jobId, date } = useParams({ from: "/job/$jobId/$date" });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentPathname = useLocation({
    select: (location) => location.pathname,
  });

  const goBack = () => {
    navigate({ to: "/" });
  };

  const goBackToOverview = () => {
    navigate({ to: "/job/$jobId/$date", params: { jobId, date } });
  };

  const showNotesModal = () => {
    dispatch(
      updateNotesModal({
        show: true,
        canAssignTask: true,
      })
    );
  };

  // Use Redux selector to get all job-related data
  const { booking, job } = useSelector((state: any) =>
    selectJobOverviewData(state, jobId)
  );

  if (!booking && !job) {
    return (
      <>
        <div className="flex-1 flex flex-col bg-gray-50 min-h-[calc(100vh-5rem)]">
          <div className="flex-1 flex items-center justify-center">
            <Card className="w-96">
              <CardHeader>
                <CardTitle>Job Not Found</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  Could not find job with ID: {jobId}
                </p>
                <Button onClick={goBack} className="w-full">
                  Back to Jobs
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <HeaderView>
        <View className="flex flex-row">
          {currentPathname === `/job/${jobId}/${date}` ? (
            <SS_Button onPress={goBack} title="Close Job" variant="outline" />
          ) : (
            <SS_Button
              onPress={goBackToOverview}
              title="Return to Overview"
              variant="outline"
            />
          )}

          <SS_Button
            className="ml-4"
            onPress={showNotesModal}
            title="Add Note to Job"
            // variant="outline"
          />
        </View>
      </HeaderView>

      <div className="flex-1 flex flex-col bg-white min-h-[calc(100vh-5rem)]">
        <div className="grid flex-1 h-full grid-cols-1 md:grid-cols-3">
          {/* Main Content Area */}
          <Outlet />
          {!currentPathname.startsWith(`/job/${jobId}/${date}/signoff`) && (
            <JobInfoPanelView booking={booking} job={job} />
          )}
        </div>
      </div>

      <NotesModal job={job} />

    </>
  );
}
